@if (type && message) {
<nz-alert
  [nzShowIcon]="showIcon"
  [nzIcon]="iconTpl"
  nzIconType="fill"
  [nzCloseable]="closeable"
  [nzType]="type"
  [nzMessage]="message"
  [nzAction]="actionTpl"
></nz-alert>
} @if (!type && message) {
<nz-alert
  class="default"
  [nzShowIcon]="showIcon"
  [nzIcon]="iconTpl"
  nzIconType="fill"
  [nzCloseable]="closeable"
  [nzMessage]="message || messageTpl"
  [nzAction]="actionTpl"
></nz-alert>
}
<ng-template #actionTpl>
  @if (actionText) {
  <a (click)="actionClick.emit()">
    {{ actionText }}
  </a>
  }
</ng-template>
<ng-template #iconTpl>
  <span nz-icon [nzType]="icon" nzTheme="fill"></span>
</ng-template>
<ng-template #messageTpl>
  <ng-content></ng-content>
</ng-template>
